// KWANKGM04220_借入申込希望書兼経営改善資金計画書_入力
// KWANKGM04260_近代化資金借入申込書_入力
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import FileUpload from '../../templates/FileUpload';
import LoadingModal from '../../molecules/LoadingModal';
import { StepNavigation as StepType } from '../../types/Template';
import { ShelfInfoObj, SetShelfInfo } from '../../types/FileUpload';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import FooterExaminationApplicantInputModernizationFunds from '../../organisms/FooterExaminationApplicantInputModernizationFunds';
import ModernizationFundsFooterAreaButtons from '../../molecules/ModernizationFundsFooterAreaButtons';
import ChangeRequest from '../../templates/ChangeRequest';
import OnlineIdentificationDialog from '../../molecules/OnlineIdentificationDialog';
import { loan_types } from '../../Const';
interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  is_loading: boolean;
  is_staff: boolean;
  opened_mypage: boolean;
  tempSave: (module_name: string) => Promise<any>;
  validate: (module_name: string) => Promise<any>;
  moveNextStep: () => void;
  guarantors_num: number;
  show_error_nav: boolean;
  display_status: boolean;
  callApi: (function_name: string) => Promise<any>;
  guarantor_info: GuarantorInfo;
  is_bank_exists: boolean;
  is_desired_bank_exists: boolean;
  is_ja_exists: boolean;
  is_mypage_ja: boolean;
  setShowErrorNav: React.Dispatch<React.SetStateAction<boolean>>;
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  reception_sub_cd: string;
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  fetchReception?: (url: string) => Promise<any>;
  setIsLoading?: (flag: boolean) => void;
  is_implement_online_identification: boolean;
  setIsImplementOnlineIdentification: React.Dispatch<React.SetStateAction<boolean>>;
  modal_open: boolean;
  setModalnOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setLabel: React.Dispatch<React.SetStateAction<string>>;
  setStepNavigation: React.Dispatch<React.SetStateAction<StepType>>;
  setDisplayReceptionCd: React.Dispatch<React.SetStateAction<boolean>>;
  setDisplayStatus: React.Dispatch<React.SetStateAction<boolean>>;
  change_request_message: string;
  is_change_modernization_funds: boolean;
  is_change_business_improvement_financing_plan: boolean;
  requestModuleWithNewContents: (function_name: string, new_contents: Content[]) => Promise<any>;
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
  requestModuleAutodisplay: (autodisplayModule: string) => void;
  is_corporate_user?: boolean;
}

const ExaminationInputModernizationFunds: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  reception_id,
  status_code,
  is_loading,
  is_staff,
  tempSave,
  validate,
  moveNextStep,
  guarantors_num,
  show_error_nav,
  display_status,
  callApi,
  guarantor_info,
  is_bank_exists,
  is_desired_bank_exists,
  is_ja_exists,
  is_mypage_ja,
  setShowErrorNav,
  shelf_info,
  setShelfInfo,
  reception_sub_cd,
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  fetchReception,
  setIsLoading,
  is_implement_online_identification,
  setIsImplementOnlineIdentification,
  modal_open,
  setModalnOpen,
  setLabel,
  setStepNavigation,
  setDisplayReceptionCd,
  setDisplayStatus,
  change_request_message,
  is_change_modernization_funds,
  is_change_business_improvement_financing_plan,
  requestModuleWithNewContents,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
  requestModuleAutodisplay,
  is_corporate_user,
}) => {
  const url = new URL(window.location.href);
  const item_id = url.searchParams.get('item_id');
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />

      {/* 借入申込変更の場合、変更依頼アコーディオンを表示 */}
      {((item_id === loan_types.business_improvement_financing_plan &&
        is_change_business_improvement_financing_plan) ||
        (item_id === loan_types.modernization_funds && is_change_modernization_funds)) && (
        <ChangeRequest change_request_message={change_request_message} />
      )}

      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
        is_bank_exists={is_bank_exists}
        is_desired_bank_exists={is_desired_bank_exists}
        is_ja_exists={is_ja_exists}
        is_mypage_ja={is_mypage_ja}
        setShowErrorNav={setShowErrorNav}
        fetchReception={fetchReception}
        setIsLoading={setIsLoading}
        setIsImplementOnlineIdentification={setIsImplementOnlineIdentification}
        requestModuleWithNewContents={requestModuleWithNewContents}
        is_corporate_user={is_corporate_user}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      {/* 確認画面の場合はファイルアップローダーの棚を表示*/}
      {looks_inactive && (
        <FileUpload
          shelf_info={shelf_info}
          setShelfInfo={setShelfInfo}
          reception={{
            reception_id: reception_id,
            reception_cd: reception_cd,
            reception_sub_cd: reception_sub_cd,
            ident_lv1_cd: ident_lv1_cd,
            ident_lv2_cd: ident_lv2_cd,
            ident_lv3_cd: ident_lv3_cd,
            status_code: status_code,
          }}
          looks_inactive={looks_inactive}
          guarantors_num={guarantors_num}
          guarantor_info={guarantor_info}
          loan_type={item_id}
          guarantor_accordion_hidden={item_id === loan_types.business_improvement_financing_plan}
          is_secured={is_secured}
          is_unsecured={is_unsecured}
          is_agricultural_modernization_funds={is_agricultural_modernization_funds}
        />
      )}
      {/* 確認画面の場合は、入力画面のボタン群を非表示*/}
      {!looks_inactive && (
        <FooterExaminationApplicantInputModernizationFunds
          is_staff={is_staff}
          reception_cd={reception_cd}
          reception_id={reception_id}
          status_code={status_code}
          tempSave={tempSave}
          validate={validate}
          moveNextStep={moveNextStep}
          is_implement_online_identification={is_implement_online_identification}
          requestModuleAutodisplay={requestModuleAutodisplay}
        />
      )}
      <ModernizationFundsFooterAreaButtons
        reception_cd={reception_cd}
        reception_id={reception_id}
        status={status_code}
        looks_inactive={looks_inactive}
        setLabel={setLabel}
        setStepNavigation={setStepNavigation}
        setDisplayReceptionCd={setDisplayReceptionCd}
        setDisplayStatus={setDisplayStatus}
      />
      <OnlineIdentificationDialog
        is_guarantor={false}
        modal_open={modal_open}
        setModalnOpen={setModalnOpen}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ExaminationInputModernizationFunds;
